export default "__VITE_ASSET__BhdIKVGw__"